import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { formatTimetoString } from '@/utils';
import { CLSTAG } from '@/utils/constant';
import { clstagStr, convertSpeedMsToKmh } from '@/utils/util';
import { Button, Modal, Table, message } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
interface Type {
  visible: boolean;
  setVisibleCb: () => {};
  vehicleName: string;
}
interface StopItem {
  name: string;
  travelStatus: string;
  travelTime: number;
  routingMileage: number;
  finishedMileage: number;
  waitingTime: number;
}
const ScheduleModel = (props: any) => {
  const { visible, setVisibleCb, vehicleName } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const timerRef = useRef<any>();
  const [scheduleInfo, setSchduleInfo] = useState<{
    scheduleNo: string;
    scheduleStartTime: string;
    scheduleState: string;
    stop: Array<StopItem>;
  }>();

  useEffect(() => {
    if (visible) {
      fetchScheduleInfo();
      timerRef.current = setInterval(() => {
        fetchScheduleInfo();
      }, 5000);
    } else {
      clearTimer();
    }
    return () => {
      clearTimer();
    };
  }, [visible]);

  const fetchScheduleInfo = async () => {
    const resp: any = await request({
      method: 'POST',
      path: `/monitor/web/schedule/realtime_schedule`,
      body: {
        vehicleName,
      },
    });
    if (resp.code === HttpStatusCode.Success) {
      const { scheduleNo, scheduleState, stop, scheduleStartTime } = resp.data;
      setSchduleInfo({
        scheduleNo: scheduleNo || '',
        scheduleState: scheduleState || '',
        stop: stop || [],
        scheduleStartTime,
      });
    } else {
      clearTimer();
      message.error(resp.message || '接口请求报错');
    }
  };
  const clearTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  const getList = () => {
    const values: any = scheduleInfo?.stop?.reduce(
      (accumulator, currentValue) => {
        accumulator[0] += parseFloat(
          (currentValue.finishedMileage / 1000).toFixed(2),
        );
        accumulator[1] += parseFloat(
          (currentValue.routingMileage / 1000).toFixed(2),
        );
        accumulator[2] += currentValue.waitingTime;
        accumulator[3] += currentValue.travelTime;
        return accumulator;
      },
      [0, 0, 0, 0],
    );

    const averageSpeed = (values[0] * 1000) / (values[3] / 1000);
    return [
      {
        key: '已行驶时长',
        value: formatTimetoString(values[3]),
      },
      {
        key: '已停靠时长',
        value: formatTimetoString(values[2]),
      },
      {
        key: '已行驶里程',
        value: `${values[0]?.toFixed(2)}/${values[1]?.toFixed(2)}km`,
      },
      {
        key: '平均速度',
        value: convertSpeedMsToKmh(averageSpeed, 1),
      },
    ];
  };
  const renderSchduleTitle = () => {
    return (
      <div className='schedule-detail-group'>
        <div className='detail-list'>
          {getList()?.map((item) => {
            return (
              <div key={item.key} className='detail-item'>
                <span>{item.key}</span>
                <span>{item.value}</span>
              </div>
            );
          })}
        </div>

        <Button
          size={'small'}
          style={{ marginBottom: '10px', marginRight: '10px' }}
          onClick={() => {
            window.open(
              `/app/shadowsystem?license=${vehicleName}&startTime=${
                scheduleInfo?.scheduleStartTime
              }&endTime=${dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`,
            );
          }}
          clstag={clstagStr(CLSTAG.MultiPage_CheckDataAnalysis)}
        >
          查看数据分析
        </Button>
      </div>
    );
  };

  const columns = [
    {
      title: '停靠点',
      dataIndex: 'stopName',
      key: 'stopName',
    },
    {
      title: '单段行驶时长',
      dataIndex: 'travelTime',
      key: 'travelTime',
      render: (text: number, record: any, index: number) => {
        return <div>{formatTimetoString(text)}</div>;
      },
    },
    {
      title: '单段行驶里程',
      dataIndex: 'finishedMileage',
      key: 'finishedMileage',
      render: (text: number, record: any, index: number) => {
        const temp = (text / 1000).toFixed(2);
        const total = (record?.routingMileage / 1000).toFixed(2);
        return (
          <div>
            {temp}/{total}km
          </div>
        );
      },
    },
    {
      title: '平均速度',
      dataIndex: 'speed',
      key: 'speed',
      render: (text: number, record: any, index: number) => {
        const finished =
          parseFloat((record?.finishedMileage / 1000).toFixed(2)) * 1000;
        const temp = finished / (record.travelTime / 1000 || 1);
        return <div>{convertSpeedMsToKmh(temp, 1)}</div>;
      },
    },
    {
      title: '该点停靠时长',
      dataIndex: 'waitingTime',
      key: 'waitingTime',
      render: (text: number, record: any) => {
        return <div>{formatTimetoString(text)}</div>;
      },
    },
  ];
  return (
    <Modal
      title={`调度详情 ${scheduleInfo?.scheduleNo}`}
      visible={visible}
      className='my-modal re-modal'
      width='1100px'
      onCancel={(e) => {
        e.stopPropagation();
        setVisibleCb();
      }}
      footer={null}
      maskClosable={false}
    >
      {scheduleInfo?.scheduleNo && renderSchduleTitle()}

      <Table
        loading={loading}
        className='my-table re-table'
        size='middle'
        rowClassName={(record, index) => {
          return record.travelTime > 0 ? 'high-light' : 'normal';
        }}
        dataSource={scheduleInfo?.stop || []}
        rowKey={(record: any) => record.stopName}
        columns={columns}
        pagination={false}
        scroll={{ y: 500 }}
      />
    </Modal>
  );
};

export default ScheduleModel;
